import { useState } from "react";
import { ArrowLeft, ArrowRight, EnvelopeSimple } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

import BrandLogo from "@/components/BrandLogo";
import { api, formatApiError } from "@/lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setIsSubmitting(true);
    try {
      const response = await api.post("/auth/forgot-password", { email });
      setMessage(response.data.message);
    } catch (requestError) {
      setError(formatApiError(requestError));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="recovery-screen" data-testid="forgot-password-page">
      <section className="recovery-panel">
        <BrandLogo testId="forgot-password-brand-logo" variant="form" />
        <p className="eyebrow">Account recovery</p>
        <h1 data-testid="forgot-password-heading">Reset your password</h1>
        <p>Enter your email address and we’ll send a secure reset link if an account matches.</p>
        {message ? (
          <div className="recovery-message" data-testid="forgot-password-success-message">
            <EnvelopeSimple aria-hidden="true" size={25} weight="duotone" />
            <p>{message}</p>
          </div>
        ) : (
          <form className="auth-form" onSubmit={submit} data-testid="forgot-password-form">
            <label htmlFor="recovery-email">Email address</label>
            <input
              id="recovery-email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="name@company.com"
              autoComplete="email"
              required
              data-testid="forgot-password-email-input"
            />
            {error && <p className="form-error" role="alert" data-testid="forgot-password-error">{error}</p>}
            <button className="primary-button" disabled={isSubmitting} data-testid="forgot-password-submit">
              {isSubmitting ? "Sending" : "Send reset link"}
              <ArrowRight aria-hidden="true" size={19} weight="bold" />
            </button>
          </form>
        )}
        <Link className="back-to-login-link" to="/login" data-testid="back-to-login-link">
          <ArrowLeft aria-hidden="true" size={18} />
          Back to sign in
        </Link>
      </section>
    </main>
  );
}